import React from 'react'
import { KampaayDataProvider } from 'services/api/dataProvider'

// poc configs
import poc1 from './poc1'
import poc2 from './poc2'

type TForms = {
  list?: React.FC
  edit?: React.FC
  create?: React.FC
}

export type PocDescriptor = {
  dp: Partial<KampaayDataProvider>
  forms: TForms
}

type ResourceName = string

/**
 * REGISTER HERE YOUR SHINY NEW POC
 */
export const pocMap: Record<ResourceName, PocDescriptor> = {
  poc1: poc1,
  poc2: poc2,
}
